export const TEST_ID = 'detailsViewPageContainer';
